import { YardIssueResponse, YardIssueType } from '@yard/app/api'

// TODO [YARD-ISSUES] - Remove when API is ready
export const YardIssueTypeDummy = {
  AllocationOverflow: 'AllocationOverflow',
  ContainerOutOfBounds: 'ContainerOutOfBounds',
  ...YardIssueType,
} as const

export type YardIssueTypeDummy = (typeof YardIssueTypeDummy)[keyof typeof YardIssueTypeDummy]

// Local IssueStatus — switch to API import when backend adds it
export const YardIssueStatus = {
  Unresolved: 'Unresolved',
  FollowUp: 'FollowUp',
  Resolved: 'Resolved',
} as const

export type YardIssueStatus = (typeof YardIssueStatus)[keyof typeof YardIssueStatus]

export interface YardIssueDto extends Pick<
  YardIssueResponse,
  | 'issueId'
  | 'blockId'
  | 'allocationRuleId'
  | 'conflictingJourneyIds'
  | 'positions'
  | 'violatingImoClass'
  | 'prohibitedBelowImoClass'
  | 'maxTiersValue'
  | 'placedImoClass'
  | 'conflictingImoClass'
  | 'requiredDistance'
  | 'actualBayDistance'
  | 'segregationConflictingJourneyId'
  | 'isProhibited'
> {
  issueType: YardIssueTypeDummy
  containerIds: number[]
  containerNumbers: string[]
  issueStatus: YardIssueStatus
  serializedPositions: string | null
}

export interface YardIssueWebSocketEvent extends YardIssueResponse {
  issueStatus: YardIssueStatus
}
